<template>
<el-drawer title="科目变更" :visible.sync="show" :before-close="close" :close-on-press-escape="false" :destroy-on-close="true" :wrapperClosable="false" :size="400">
	<p style="font-size: 20px;font-weight: 700;padding-left: 10px;margin-bottom: 20px;">将<span style="color: #f00;">{{name}}</span>的主要科目变更为：</p>
	<el-form :model="form" :rules="rules" ref="form" label-width="100px">
		<el-form-item class="item" label="职务" prop="sub">
			<el-select v-model="form.sub" placeholder="职务"><el-option v-for="onesub in sub" :key="'firstsub'+onesub.id" :label="onesub.nj+onesub.sub" :value="onesub.id"></el-option></el-select>
		</el-form-item>
		
		<el-form-item class="item" label="起始日期" prop="startTimeS">
			<el-date-picker style="width: 200px;" v-model="form.startTimeS" type="date" placeholder="选择日期"></el-date-picker>
		</el-form-item>
		
		<div class="m15" style="text-align: right;">
			<el-button @click="reset">重置</el-button>
			<el-button type="primary" @click="submit">提交</el-button>
		</div>
	</el-form>
</el-drawer>
</template>

<script>
export default{
	name:'repsub',
	data() {
		return {
			name:"",
			mysub:"",
			startTimeS:"",
			form:{
				sub:"",
				startTimeS:""
			},
			rules:{
				sub:[{validator:(rule,value,callback)=>{
					if(this.form.sub===""){
						callback("请选择主要职务")
						return
					}
					if(this.form.sub===this.mysub&&this.startTimeS===this.myfun.date2str(this.form.startTimeS)){
						callback("科目未更改")
						return
					}
					callback()
				},trigger:'blur'}],
				startTimeS:[{validator:(rule,value,callback)=>{
					if(this.form.startTimeS===""){
						callback("请选择起始日期")
					}
					callback()
				},trigger:'blur'}]
			}
		}
	},
	props:{
		user:{
			type:Object
		},
		show:{
			type:Boolean
		},
		sub:{
			type:Array
		}
	},
	watch:{
		show(n){
			if(!n){
				return
			}
			this.name=this.user.name
			this.mysub=this.user.sub.id,
			this.form.sub=this.user.sub.id,
			this.startTimeS=this.user.sub.stime
			this.form.startTimeS=this.user.sub.stime
		}
	},
	methods:{
		close(){
			this.$emit("close",{isrep:false})
		},
		reset(){
			this.$refs.form.resetFields()
		},
		submit(){
			this.$refs.form.validate((e)=>{
				if(!e){
					return
				}
				//整理数据，提交服务器
				let user={
					id:this.user.id,
					sub:{
						id:this.form.sub,
						stime:this.myfun.date2str(this.form.startTimeS),
					}
				}
				this.myfun.Loading()
				const formdata = new FormData()
				formdata.append("user",JSON.stringify(user))
				this.axios.post("data:repsub",formdata).then(e=>{
					this.myfun.Loadingclose()
					if(!e)return
					this.myfun.messageSuc("修改成功")
					this.$emit("close",{isrep:true,data:e})
				})
			})
		}
	}
}
</script>

<style>
</style>
